import {AccessLevel} from '$lib/classes/_enum/access-level';

export class FreeLimitReached {

    current: boolean = $derived.by(() => {
        return this.getAccessLevel() === AccessLevel.FreeTier && this.getReviewCount() >= this.maxCount
    })

    constructor(
        private readonly getAccessLevel: () => AccessLevel,
        private readonly getReviewCount: () => number,
        private readonly maxCount: number,
    ) {
        // TODO refactor when upgraded to Svelte > 5.31 (+remove 'private readonly' modifier)
        // this.current = $derived(getAccessLevel() === AccessLevel.FreeTier && getReviewCount() >= REVIEW_COUNT_MAX);
    }
}